import { Loader } from '@shared/designSystem/Loader'
import { ReactComponent as ArrowsSVG } from '@assets/SVGs/QontactPoint/ArrowSVG.svg'
import { usePopup } from "@contexts/popupContext"
import styles from '@styles/components/Novedades/ComunicarNovedad.module.css'
import { useState } from "react"

import Image from "@components/General/Image"
import { MultiDatePickerPopper, NovedadPickerPopper } from '@components/General/TablePoppers'
import CircularCheckbox from "@components/General/CircularCheckbox"




const EditarNovedad = ({ onAccept, colaboradorName, colaboradorPhoto, novedad, novedades, defaultDate}) => {
    const {hidePopup} = usePopup()
    const [open, setOpen] = useState(false)
    const [openRangeDate, setOpenRangeDate] = useState(false)
    const [openSpecificDate, setOpenSpecificDate] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [innerNovedad, setInnerNovedad] = useState(novedad)
    const [fechas, setFechas] = useState([defaultDate])
    const [chosenDateType, setChosenDateType] = useState('Unica')
    const [loading, setLoading] = useState(false)

    const processName = (name) => {
        const words = name.split(' ');
        const processedWords = words.map(word => {
            const firstLetter = word.charAt(0).toUpperCase();
            const restOfWord = word.slice(1).toLowerCase();
            return firstLetter + restOfWord;
        });
        return processedWords.join(' ');        
    }

    const handleClickOnNovedadPicker = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen((previousOpen) => !previousOpen);
    };


    const handleClickOnDateInput = (event, dateInputID) => {
        setChosenDateType(dateInputID)
        if (dateInputID === 'Unica') {
            setFechas([defaultDate])
            setOpenRangeDate(false)
            setOpenSpecificDate(false)
            return
        }


        setAnchorEl(event.currentTarget);
        if (dateInputID === 'Rango') {
            setOpenRangeDate((previousOpen) => !previousOpen);
            if (chosenDateType === 'Unica') {
                setFechas([])
            }
        } else if (dateInputID === 'Especificas') {
            setOpenSpecificDate((previousOpen) => !previousOpen);
            if (chosenDateType === 'Unica') {
                setFechas([])
            }
        }
    }

    const handleAcceptDateInput = (dates) => {
        setFechas(dates)
        setOpenRangeDate(false)
        setOpenSpecificDate(false)
    }

    return (
        <div className={styles['popup']}>
            <div className={styles['colaborador-container']} style={{marginBottom: '25px'}}>
                <div className={styles['circle-mask']}  style={{width: '24px', height: '24px', marginRight: '10px', display: 'inline-block', verticalAlign: 'top'}}>
                    <Image src={colaboradorPhoto || '/assets/Q.png'} alt="Profile Picture" isRound={true} style={{width: '100%', height: '100%'}}/>
                </div>
                <div style={{
                    display: 'inline-block', 
                    maxWidth: 'calc(100% - 34px)',
                    fontSize: '14px',
                    color: '#101828', 
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap', 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis'
                }}>  
                    {processName(colaboradorName)}
                </div>
            </div>
            <div className={styles['title']} style={{marginBottom: '25px'}}>Editar Novedad</div>

            <div className={styles['novedades-input-container']} onClick={handleClickOnNovedadPicker}>
                {!innerNovedad ?
                    <>Seleccionar</>
                    : 
                    <>
                    <div className={styles['novedadpicker-svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                        {innerNovedad.acronym}
                    </div>
                    <p className={styles['novedadpicker-dropdown-text']}>{innerNovedad.name}</p>
                    </>
                }

                <div className={styles['svg-container']} style={{
                    marginLeft: 'auto', width: '14px', height: '15px',
                    transform: open ? 'none' : 'rotate(180deg)',
                    transition: 'transform 0.2s ease'
                }}>
                    <ArrowsSVG/>
                </div>
            </div>
            {open && <NovedadPickerPopper 
                isOpen={open} 
                anchorElement={anchorEl} 
                placement='bottom' 
                clickAwayHandler={() => setOpen(false)}
                novedades={novedades}
                selectedNovedad={innerNovedad}
                setSelectedNovedad={setInnerNovedad}
                zIndex={1001}
            />}

            <div className={styles['fecha-input-container']} onClick={(event) => handleClickOnDateInput(event, "Unica")}>
                <CircularCheckbox value={chosenDateType === 'Unica' ? true : false} onChange={() => {}}/>
                <p style={chosenDateType === 'Unica' ? {color: '#323649'} : {}}>{defaultDate}</p>
            </div>

            <div className={styles['fecha-input-container']} onClick={(event) => handleClickOnDateInput(event, "Especificas")}>
                <CircularCheckbox value={chosenDateType === 'Especificas' ? true : false} onChange={() => {}}/>
                <p style={chosenDateType === 'Especificas' ? {color: '#323649'} : {}}>Elegir fechas</p>
                {openSpecificDate && <MultiDatePickerPopper 
                    isOpen={openSpecificDate} 
                    anchorElement={anchorEl} 
                    placement='bottom' 
                    clickAwayHandler={() => setOpenSpecificDate(false)}
                    selectedDates={fechas}
                    setSelectedDates={handleAcceptDateInput}
                    zIndex={1001}
                />}
            </div>

            <div className={styles['fecha-input-container']} onClick={(event) => handleClickOnDateInput(event, "Rango")}>
                <CircularCheckbox value={chosenDateType === 'Rango' ? true : false} onChange={() => {}}/>
                <p style={chosenDateType === 'Rango' ? {color: '#323649'} : {}}>Definir rango</p>
                {openRangeDate && <MultiDatePickerPopper 
                    isOpen={openRangeDate} 
                    anchorElement={anchorEl} 
                    placement='bottom' 
                    clickAwayHandler={() => setOpenRangeDate(false)}
                    selectedDates={fechas}
                    setSelectedDates={handleAcceptDateInput}
                    zIndex={1001}
                    range={true}
                />}
            </div>


            <div className={styles['bottom-container']}>
                    <div className={`${styles['button']} ${styles['cancelar']}`} onClick={() => {
                        if (loading) return
                        hidePopup()
                    }}>
                        Cancelar
                    </div>

                    <div className={`${styles['button']} ${styles['agregar']}`} onClick={() => {
                        if (loading) return

                        let isSameDay = false
                        if (chosenDateType === 'Unica') {
                            isSameDay = true
                        }
                        onAccept(innerNovedad, fechas, isSameDay)
                        setLoading(true)
                    }}>
                        {!loading ? 'Guardar'
                        :
                        <div className={styles['no-qontact-points']}>
                            <Loader height="32px" width="32px" />
                        </div>
                        }
                    </div>
            </div>

        </div>
    )
}

export default EditarNovedad
